import { render, staticRenderFns } from "./product_tmall.vue?vue&type=template&id=62776306&scoped=true"
import script from "./product_tmall.vue?vue&type=script&lang=js"
export * from "./product_tmall.vue?vue&type=script&lang=js"
import style0 from "./product_tmall.vue?vue&type=style&index=0&id=62776306&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "62776306",
  null
  
)

export default component.exports